function sampleElementSelectDirective(){
	return{
		scope: {
			sampleElement:'=',
			type : '@',
			required : '@'
		},
		restrict: 'E',
		replace : true,
		templateUrl: function(elem, attr) {
			return 'views/directives/sampleElementSelectDirective.html';
		},
		controller: ['$scope', '$window', 'alertService', 'sampleElementService',function($scope, $window, alertService, sampleElementService){
			$scope.availableSamplesElements = [];
			
			$scope.searchSamplesElements = function(query) {
				var filter = {
					name: query
				};
				
				if($scope.type){
					filter.sampleElementType = $scope.type;
				}

				sampleElementService.searchSamplesElements(filter).then(function(response) {
					$scope.availableSamplesElements = response.getData().results;
                }, function(response) {
                	//on error
                });
			};
		}]
	};
};

module.directive('sampleElementSelect', [ sampleElementSelectDirective ]);